import { authedEndpoint } from "../../builder";
import {
    productionExport,
    updateProductionExportSchema,
} from "../../schemas/production-export";

export const put = authedEndpoint.mutation((data) => ({
    input: updateProductionExportSchema,
    json: data,
    method: "put",
    output: productionExport,
    url: "export-settings",
}));
